import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_ROADMAPS_FEED_ROUTES as ROUTES } from './utils'
import { lkStoreModule } from '@/store/modules/lk'


export { LK_ROADMAPS_FEED_ROUTES } from './utils'

type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'roadmaps',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "roadmaps-lk-feed.store" */
        './store'
      )
      registerModule(options)

      const storeModule = lkStoreModule.context(options.store)

      const promises = [
        storeModule.actions.getTopics().catch(() => ({})),
        storeModule.actions.getRoadmapsCount().catch(() => ({})),
        storeModule.actions.getMunMehCount().catch(() => ({})),
      ]

      await Promise.all(promises)

      next()
    },
    component: (): PromiseVue => import(
      /* webpackChunkName: "roadmaps-lk-feed.layout" */
      './LKRoadmapsFeedLayout.vue'
    ),
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        component: (): PromiseVue => import(
          /* webpackChunkName: "roadmaps-lk-feed.list" */
          './LKRoadmapsFeedIndex.vue'
        ),
      },
      {
        path: ':id(\\d+)/school/:school_id',
        name: ROUTES.VIEW,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "roadmaps-lk-feed.view" */
          './LKRoadmapsFeedView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
